/* global  */ // tUrl等のグローバル変数を宣言する

import './_smoothScroll.js' // スムーズスクロール
import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,#' + accBtn + '-close,#' + accBtn + ' a').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,#' + accBtn + '-close').toggleClass('active')
  })

  /*** Swiper ***/
  // eslint-disable-next-line no-unused-vars, no-undef
  let mySwiper = new Swiper('.swiper-container', {
    loop: true,
    // nextButton: '.swiper-button-next',
    // prevButton: '.swiper-button-prev',
    speed: 2000, // スライドが切り替わるトランジション時間(ミリ秒)。
    slidesPerView: 1, // 何枚のスライドを表示するか
    spaceBetween: 20, // スライド間の余白サイズ(ピクセル)
    direction: 'horizontal', // スライド方向。 'horizontal'(水平) か 'vertical'(垂直)。effectオプションが 'slide' 以外は無効。
    effect: 'fade', // "slide", "fade"(フェード), "cube"(キューブ回転), "coverflow"(カバーフロー) または "flip"(平面回転)
    // スライダーの自動再生(デフォ自動)
    autoplay: {
      delay: 4000, // スライドが切り替わるまでの表示時間(ミリ秒)
      stopOnLast: false, // 最後のスライドまで表示されたら自動再生を中止するか
      disableOnInteraction: false // ユーザーのスワイプ操作を検出したら自動再生を中止するか
    }
    /*
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    */
    /*
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets'
    },
    */
    // レスポンシブ化
    // breakpoints: {
    //   768: {}
    // }
  })

  /* 採用Q&Aのアコーディオン処理　*/
  $('#sp-ex-acc1, #sp-ex-acc2, #sp-ex-acc3').on('click', function() {
    $(this).toggleClass('is-open')
  })

  // const targetURL = [
  //   // ローカル環境URL
  //   'http://192.168.0.90:3000/news/',
  //   // ステージングURL
  //   'http://stg-spc.net/projects/tokyo-rusk/news/',
  //   // 本番URL
  //   'https://prd-hogehoge/'
  // ]
  // $(window).on('load', function() {
  //   let isURLmatch = false
  //   let thisPageURL
  //   thisPageURL = $(location).attr('href')

  //   for (let i = 0; i < targetURL.length; i++) {
  //     if (thisPageURL.match(targetURL[i])) {
  //       isURLmatch = true
  //     }
  //   }

  //   if (isURLmatch) {
  //     $('.no-toppage-hide').addClass('active')
  //   }
  // })
})
